module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-600.36ab1101.svg";